export default __webpack_public_path__ + "static/media/sportsbra-large-back.fbca555d.jpg";